import React, { FC } from "react";
import FilterForm from 'components/FilterForm/(flight-search-form)/FilterForm';

export interface SectionHeroProps {
  className?: string;
}

const SectionFilter: FC<SectionHeroProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="hidden lg:block z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <FilterForm />
      </div>
    </div>
  );
};

export default SectionFilter;
